import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { computed } from 'vue';
import { head, last } from 'lodash';
import { StLetterFilter } from './letter-filter.styled';
import { props as propsDefinition} from './letter-filter.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterFilter',
  props: propsDefinition,
  emits: [ 'update:modelValue' ],
  setup(__props, { emit }) {

const props = __props




const letters = [
  'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
  'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
];

const groupLetters = computed(() => {
  const result: string[][] = [];
  let index = 0;

  while (index < letters.length) {
    if ( index + props.letterGroupSize >= letters.length ) {
      if ( letters.length - index === 1 && result.length > 0 ) {
        result[result.length - 1].push(letters[index]);
      } else {
        result.push(letters.slice(index));
      }
      break;
    }

    result.push(letters.slice(index, index + props.letterGroupSize));
    index += props.letterGroupSize;
  }

  return result;
});

const displayGroupLetters = computed(() => {
  if ( props.letterGroupSize === 1 ) {
    return groupLetters.value.map((letterArray) => (head(letterArray)));
  }

  return groupLetters.value.map((letterArray) => (`${ head(letterArray) } - ${ last(letterArray) }`));
});

const handleLetterSelected = (index: number) => {
  const lettersSelected = groupLetters.value[index].join(',');

  if ( lettersSelected !== props.modelValue ) {
    emit('update:modelValue', lettersSelected);
  } else {
    emit('update:modelValue', '');
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StLetterFilter), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayGroupLetters), (letter, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: letter,
          class: _normalizeClass(["list__letter", {active: props.modelValue === _unref(groupLetters)[index].join(',')}]),
          onClick: ($event: any) => (handleLetterSelected(index))
        }, _toDisplayString(letter), 11, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }))
}
}

})